import {useMount as _useMount} from 'react-use';

import constants from '@constants';
import paths from '@paths';

export const useMount = (me: MeStore, history: any) => {
  _useMount(() => {
    if (me.plan === constants.PLAN.FREE) {
      history.push(paths.dashboard.main);
    }
  });
};
